export const TEST_ID = 'statusPill';
